import {
  RESET_DEPARTMENTS,
  RESET_DEPARTMENT,
  RESET_ERROR,
  GET_DEPARTMENTS,
  SET_DEPARTMENTS,
  API_ERROR,
  GET_DEPARTMENT,
  SET_DEPARTMENT,
  CREATE_DEPARTMENT,
  CREATE_DEPARTMENT_SUCCESS,
  EDIT_DEPARTMENT,
  EDIT_DEPARTMENT_SUCCESS,
  DELETE_DEPARTMENT,
  DELETE_DEPARTMENT_SUCCESS,
} from "./actionTypes";

export const resetDepartments = () => {
  return {
    type: RESET_DEPARTMENTS,
    payload: {},
  };
};

export const resetDepartment = () => {
  return {
    type: RESET_DEPARTMENT,
    payload: {},
  };
};

export const resetError = () => {
  return {
    type: RESET_ERROR,
    payload: {},
  };
};

export const getDepartments = (idCompany, page, qnt, name, email, slug, isForm) => {
  return {
    type: GET_DEPARTMENTS,
    payload: { idCompany, page, qnt, name, email, slug, isForm },
  };
};
export const setDepartments = (data, qtdDefault, idCompany) => {
  const maxPage = Math.ceil(data.total / qtdDefault);
  var paging = Array.from({ length: maxPage }, (v, k) => k + 1);

  return {
    type: SET_DEPARTMENTS,
    payload: { ...data, paging, idCompany },
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};

export const createDepartment = (newDepartmentValues, idCompany) => {
  return {
    type: CREATE_DEPARTMENT,
    payload: { newDepartmentValues, idCompany },
  };
};
export const createDepartmentSuccess = (message) => {
  return {
    type: CREATE_DEPARTMENT_SUCCESS,
    payload: { message },
  };
};

export const getDepartment = (idDepartment, idCompany, isForm) => {
  return {
    type: GET_DEPARTMENT,
    payload: { idDepartment, idCompany, isForm },
  };
};
export const setDepartment = (data) => {
  return {
    type: SET_DEPARTMENT,
    payload: { data },
  };
};

export const editDepartment = (
  idDepartment,
  newDepartmentValues,
  idCompany
) => {
  return {
    type: EDIT_DEPARTMENT,
    payload: { idDepartment, newDepartmentValues, idCompany },
  };
};
export const editDepartmentSuccess = (message) => {
  return {
    type: EDIT_DEPARTMENT_SUCCESS,
    payload: { message },
  };
};

export const deleteDepartment = (idDepartment, idCompany) => {
  return {
    type: DELETE_DEPARTMENT,
    payload: { idDepartment, idCompany },
  };
};
export const deleteDepartmentSuccess = (message) => {
  return {
    type: DELETE_DEPARTMENT_SUCCESS,
    payload: { message },
  };
};
